import { useState, Children, cloneElement, isValidElement } from 'react';

export function Tabs({ children, defaultValue, value, onValueChange }) {
  const [internalValue, setInternalValue] = useState(defaultValue);
  const activeValue = value !== undefined ? value : internalValue;
  const setActive = (v) => {
    if (onValueChange) onValueChange(v)
    else setInternalValue(v)
  }

  return (
    <div>
      {Children.map(children, child => isValidElement(child) ? cloneElement(child, { activeValue: activeValue, setActive }) : child)}
    </div>
  );
}
export function TabsList({ children, activeValue, setActive }) {
  return (
    <div className="flex gap-2 border-b pb-1">
      {Children.map(children, child => isValidElement(child) ? cloneElement(child, { activeValue, setActive }) : child)}
    </div>
  );
}
export function TabsTrigger({ value, children, activeValue, setActive, disabled }) {
  const active = activeValue === value;
  return (
    <button
      disabled={disabled}
      className={`px-3 py-1 rounded ${active ? 'bg-blue-500 text-white' : ''} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      onClick={() => !disabled && setActive(value)}
    >
      {children}
    </button>
  );
}
export function TabsContent({ value, children, activeValue }) {
  return activeValue === value ? <div className="pt-2">{children}</div> : null;
}
